import { graphql } from '@/generated/gql';

export const INTAKE_BUDGET_SET_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeBudgetMutation($data: SvbrgRequestBudgetInput!) {
    sevenbridges {
      chatSession {
        budget {
          next(data: $data) {
            accountingAreaId
            budget
            commodityGroupId
            costCenterId
            currency
            deliveryLocationId
            id
            lineItems {
              commodityGroupId
              unitId
              description
              earlyDeliveryAt
              expectedPricePerUnit
              id
              lateDeliveryAt
              position
              quantity
              sequence
              title
            }
            organizationId
          }
        }
      }
    }
  }
`);
